import { FC, ReactNode, RefObject } from 'react';

import { ActivatorElementType, Placement } from '@hh.ru/magritte-internal-drop-base';
import { BottomSheet, NavigationBar, Tooltip, TooltipHover, VSpacing } from '@hh.ru/magritte-ui';

import styles from 'components/common/TooltipCommon/TooltipCommon.module.less';

interface TooltipCommonProps {
    activatorRef: RefObject<ActivatorElementType>;
    tooltipContent: ReactNode;
    onClose: () => void;
    isHoverTooltip?: boolean;
    bottomSheetTitle?: string;
    maxWidth?: number;
    tooltipActions?: ReactNode;
    bottomSheetFooter?: ReactNode;
    visible?: boolean;
    placement?: Placement;
    showClose?: boolean;
}

export const TooltipCommon: FC<TooltipCommonProps> = ({
    activatorRef,
    tooltipContent,
    onClose,
    isHoverTooltip,
    bottomSheetTitle,
    maxWidth,
    tooltipActions,
    bottomSheetFooter,
    visible = false,
    placement = 'top-center',
    showClose = false,
}) => {
    return (
        <>
            {isHoverTooltip ? (
                <TooltipHover
                    maxWidth={maxWidth}
                    activatorRef={activatorRef}
                    placement={placement}
                    onClose={onClose}
                    buttons={tooltipActions}
                >
                    {tooltipContent}
                </TooltipHover>
            ) : (
                <Tooltip
                    maxWidth={maxWidth}
                    visible={visible}
                    activatorRef={activatorRef}
                    placement={placement}
                    onClose={onClose}
                    buttons={tooltipActions}
                    showClose={showClose}
                >
                    {tooltipContent}
                </Tooltip>
            )}
            <BottomSheet
                withContentPaddings={false}
                header={bottomSheetTitle ? <NavigationBar title={bottomSheetTitle} /> : undefined}
                onClose={onClose}
                visible={visible}
                footer={bottomSheetFooter}
            >
                <div className={styles.bottomSheetWrapper}>
                    {!bottomSheetTitle && <VSpacing default={16} />}
                    {tooltipContent}
                </div>
            </BottomSheet>
        </>
    );
};
